import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import ConnectionRuns from './ConnectionRuns';
import ConnectionRunsTabState from './ConnectionRunsTabState';

export default class ConnectionRunsTabView extends BufferTabView<ConnectionRunsTabState> {
  render(): this {
    const props = {
      connectionId: this.model.get('connectionId'),
    };
    renderToDOM(
      <div className="react-tab-container">
        <ConnectionRuns {...props} />
      </div>,
      this.el
    );
    return this;
  }

  remove(): Backbone.View<ConnectionRunsTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

ConnectionRunsTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
